export default {
  exportJob: state => state.exportJob,
  count: state => state.count,
  // above are being used while saving data in exportJob
  sbMain: state => state.sbMain,
  invoice: state => state.invoice,
  item: state => state.item,
  license: state => state.license,
  ar4: state => state.ar4,
  drawback: state => state.drawback,
  statement: state => state.statement,
  container: state => state.container,
  packingList: state => state.packingList,
  swInfoType: state => state.swInfoType,
  currency: state => state.invoice.invoiceCurrencyCode,
  exchangeRate: state => state.exchangeRate,
  invoiceValue: state => state.invoice.invoiceValue,
  supportingDoc: state => state.supportingDoc,
  schemeAbbreviations: state => state.schemeAbbreviations,
  isInvoiceProductsPagePassed: state => state.isInvoiceProductsPagePassed,
  exportJobId: state => state.exportJobId
};
